/**
 * The positions an Honorary Fellow may not hold.
 *
 * An honorary membership is held ALONGSIDE the person's own Member Association, so the seats it
 * rules out are the ones that would put the two associations in conflict over the same person:
 * the board seats, and the CoD seats that carry a nomination for the elections. Mirrors
 * App\Security\HonoraryRoleRestrictions on the API, which refuses them whatever the screen sends.
 */
export const HONORARY_FORBIDDEN_ROLES = [
  'ROLE_MA_PRESIDENT',
  'VICE_PRESIDENT',
  'CHAIR_OF_THE_BOARD',
  'BOARD_MEMBER',
  'MANAGING_DIRECTOR',
  'MEMBER_OF_STRATEGIC_ADV_BOARD',
  'COD_DELEGATE',
  'COD_SUBSTITUTE',
];

/**
 * @param {Array}   roles    role options, each carrying the API role `name`
 * @param {boolean} honorary whether the position being given is an honorary one
 */
const filterHonoraryRoles = (roles, honorary) =>
  honorary ? roles.filter((role) => !HONORARY_FORBIDDEN_ROLES.includes(role.name)) : roles;

export default filterHonoraryRoles;
